export var SocialNetwork;

(function (SocialNetwork) {
  SocialNetwork["FACEBOOK"] = "FACEBOOK";
  SocialNetwork["LINKEDIN"] = "LINKEDIN";
  SocialNetwork["TWITTER"] = "TWITTER";
  SocialNetwork["GOOGLE_CLASSROOM"] = "GOOGLE_CLASSROOM";
})(SocialNetwork || (SocialNetwork = {}));

var SocialLinks = {
  [SocialNetwork.FACEBOOK]: 'https://www.facebook.com/sharer.php?u=',
  [SocialNetwork.LINKEDIN]: 'https://www.linkedin.com/shareArticle?url=',
  [SocialNetwork.TWITTER]: 'https://twitter.com/share?url=',
  [SocialNetwork.GOOGLE_CLASSROOM]: 'https://classroom.google.com/share?url='
};
var popUpDimensions = {
  width: 520,
  height: 570
};
export var openSocialNetworkPopup = function openSocialNetworkPopup(shareUrl) {
  var left = window.innerWidth / 2 - popUpDimensions.width / 2 + window.screenX;
  var top = window.innerHeight / 2 - popUpDimensions.height / 2 + window.screenY;
  window.open(shareUrl, '_blank', `location=yes,height=${popUpDimensions.height},width=${popUpDimensions.width},scrollbars=yes,status=yes,left=${left},top=${top}`);
};
export var getSocialNetworkUrl = function getSocialNetworkUrl(network, preziTitle) {
  var tags = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  if (network === SocialNetwork.GOOGLE_CLASSROOM) {
    return SocialLinks[network] + encodeURIComponent(window.location.href) + `&title=${encodeURIComponent(preziTitle)}`;
  }

  var hashtags = tags.length > 0 && tags[0] !== '' ? tags.join(',') : null;
  return SocialLinks[network] + encodeURIComponent(window.location.href) + `&text=${encodeURIComponent(preziTitle)}` + (hashtags ? `&hashtags=${encodeURIComponent(hashtags)}` : '');
};